// extracted by mini-css-extract-plugin
export default {"wrapper":"alert_wrapper__kHDxR","icons":"alert_icons__9BRqV","message":"alert_message__JH4pl"};